import React from 'react';
import PropTypes from 'prop-types';
import CDU from 'control-cdu';
import AppUtils from '@control-front-end/utils/utils';
import { ErrorBoundary } from 'react-error-boundary';
import { Button, Icon, Label, Utils } from 'mw-style-react';
import { APP_AUTH_KEY } from 'constants';
import useIntl from 'useIntl';
import { useSelector } from 'react-redux';
import mes from '../../intl';
import '../../ScriptFilePreview.scss';

function PagePreview({ accId, app, stage, page }) {
  const t = useIntl();
  const { widgetUrl } = useSelector((state) => state.config);
  const errorFallback = ({ error, resetErrorBoundary }) => (
    <div styleName="sfp__error">
      <div styleName="sfp__error__info">
        <Icon type="alert" error />
        <Label fontWeight="semibold" value={t(mes.pageError)} />
        &nbsp;
        <Label value={error.message} />
      </div>
      <Button
        styleName="sfp__error__btn"
        size="small"
        fontWeight="normal"
        icon="repeat"
        label={t(mes.refreshPage)}
        onClick={resetErrorBoundary}
      />
    </div>
  );

  return (
    <ErrorBoundary FallbackComponent={errorFallback}>
      <CDU
        auth={Utils.fromStorage(APP_AUTH_KEY)}
        workspace={accId}
        app={app}
        stage={stage}
        debug={true}
        page={`${page}?a=${AppUtils.udid()}`}
        widgetUrl={widgetUrl}
        whiteLabel
      />
    </ErrorBoundary>
  );
}

PagePreview.propTypes = {
  accId: PropTypes.string,
  app: PropTypes.string.isRequired,
  stage: PropTypes.string.isRequired,
  page: PropTypes.string.isRequired,
};

export default PagePreview;
